export const Constantes = {


  ABIERTO: 'ABIERTO',
  OBSERVACIONES: 'OBSERVACIONES',
  PROCESO: 'PROCESO',
  RESUELTO: 'RESUELTO',
  REVISION: 'REVISION',
  VOBO: 'VOBO',
  CANCELADO: 'CANCELADO',

  ABIERTOCOLOR: '#26a69a',
  OBSERVACIONESCOLOR: '#ff9800',
  PROCESOCOLOR: '#2196f3',
  RESUELTOCOLOR: '#916EFF',
  REVISIONCOLOR: '#3C4858',
  VOBOCOLOR: '#e91e63',
  CANCELADOCOLOR: '#999999',
  /**TICKETS(SEMÁFORO) */
  GREEN: '#4caf50',
  YELLOW: '#ffc107',
  RED: '#f44336',
  PINK: '#e91e63',
  ENTIEMPO: 'En Tiempo',
  ADESTIEMPO: 'A destiempo',
  FUERADETIEMPO: 'Fuera de Tiempo',
  DIEZ: 10,
  VEINTE: 20,
  CINCUENTA: 50,
  CERO: 0,
  UNO: 1,
  DOS: 2,
  CUATRO: 4,
  CINCO: 5,
  OCHO: 8,
  CATORCE: 14,
  SESENTA: 60,
  MIL: 1000,
  VACIO: '',
  SPACE: ' ',
  EXITO: '00000',
  COD_EXITO: 'EXITO',
  ERROR_00010 : '00010',
  SEPARATOR: '¬',
  SEPARATOR_VALUE: '|',
  DOS_PUNTOS: ':',
  FILTRO_CODIGO: 'codigo',
  FILTRO_FOLIO: 'folio',
  FILTRO_NOMBRE: 'nombre',
  FILTRO_ID: 'id',
  FILTRO_FECHA: 'fechaActualiza',
  ELEMENTO: 'elemento',
  FLUJO: 'flujo',
  FACTORY: 'factory',
  TAMANIO_DIALOG: '350',
  CAJA: 'caja',
  VENTA: 'venta',
  MXP: 'MXP',
  USD: 'USD',
  EMPRESA_DEFAULT: 1,
  CORPORATIVO_DEFAULT: 1001,

  SIN_RESULTADOS: "No hay actividades para esta consulta",
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SIN_REGISTROS: "No se tienen registradas actividades.",
  FORMATO_HORA_MINUTOS: 'HH:mm',
  TAREA_SIN_PROGRAMAR: 'TAREA_SIN_PROGRAMAR',
  SOLICITUD_MEJORA: 'MEJORA',
  SOLICITUD_PERFIL: 'PERFIL',

  //Area perfil
  AREA_RESOLUTORA: "Reclutamiento",
  PROYECTO_VACACIONES: "Registro Vacaciones"
};